import React, { useState } from "react";
import { ReactComponent as ProfileImage } from "../../assets/images/profile.svg";
import { getCountryByCode } from "../../utils/Helper";
import { capitalize } from "../../global_functions/global";
export const SearchItem = ({
  company,
  index,
  activeItem,
  getSelectedCompany,
}) => {
  return (
    <div onClick={() => getSelectedCompany(company, index)} className={`flex justify-between items-center border p-2 rounded-md cursor-pointer mb-2 ${activeItem === index ? "border border-primary" : "border-slate"
      }`}>
      <div

        className={`flex gap-2`}
      >
        <ProfileImage width="40" height="40" />
        <div>
          <h6 className="text-f14 text-primary text-left">{company?.name || company?.registered_company_name}</h6>
          <div className="flex items-center justify-start gap-2">
            <div>
              <svg
                width="12"
                height="13"
                viewBox="0 0 12 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_2593_10347)">
                  <path
                    d="M10.5 5.5C10.5 9 6 12 6 12C6 12 1.5 9 1.5 5.5C1.5 4.30653 1.97411 3.16193 2.81802 2.31802C3.66193 1.47411 4.80653 1 6 1C7.19347 1 8.33807 1.47411 9.18198 2.31802C10.0259 3.16193 10.5 4.30653 10.5 5.5Z"
                    stroke="#28475C"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M6 7C6.82843 7 7.5 6.32843 7.5 5.5C7.5 4.67157 6.82843 4 6 4C5.17157 4 4.5 4.67157 4.5 5.5C4.5 6.32843 5.17157 7 6 7Z"
                    stroke="#28475C"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2593_10347">
                    <rect
                      width="12"
                      height="12"
                      fill="white"
                      transform="translate(0 0.5)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <span className="text-f12 text-secondary">
              {company?.state &&
                capitalize(company?.state) + ","}{" "}
              {getCountryByCode(company?.country_code)}
            </span>
          </div>
        </div>
      </div>
      <div className="w-[10px] h-[10px] rounded-full" style={{backgroundColor: company?.verifiedCompany ? "#269758" : company?.claimed ? "#0094FF" : company?.secondary ? "#FF9700" : "#3C4848"}}></div>
    </div>
  );
};
